import { useContext } from 'react'
import { DashboardContext } from './dashboardContext'

export const useDashboard = () => {
  const context = useContext(DashboardContext)
  if (!context) {
    throw new Error('useDashboard must be wrapped within a DashboardProvider')
  }
  return context
}

export default useDashboard
